import { ChevronLeft, ChevronRight } from "lucide-react";
import HTMLFlipBook from "react-pageflip";
import { forwardRef, useRef, useState } from "react";
import { getAssetUrl } from "../lib/api";

const AlbumPage = forwardRef(function AlbumPage({ image, number }, ref) {
  return (
    <div className="album-page" ref={ref} data-density="hard" data-testid={`album-page-${number}`}>
      <img src={getAssetUrl(image)} alt={`Eylül Fotoğrafçılık albüm karesi ${number}`} loading="lazy" data-testid={`album-image-${number}`} />
      <span className="album-page-number">{String(number).padStart(2, "0")}</span>
    </div>
  );
});

export default function FlipAlbum({ images }) {
  const book = useRef(null);
  const [opened, setOpened] = useState(false);

  if (!opened) {
    return (
      <div className="flip-album-wrap album-cover-stage" data-testid="virtual-album">
        <button className="album-cover" onClick={() => setOpened(true)} data-testid="album-cover-open-button">
          <img src={getAssetUrl(images[0])} alt="Eylül Fotoğrafçılık kapalı albüm kapağı" data-testid="album-cover-image" />
          <span>EYLÜL FOTOĞRAFÇILIK</span>
          <small>Albümü açmak için dokunun</small>
        </button>
      </div>
    );
  }

  return (
    <div className="flip-album-wrap" data-testid="virtual-album">
      <HTMLFlipBook
        className="flip-book"
        drawShadow
        flippingTime={850}
        height={650}
        maxHeight={650}
        maxWidth={1120}
        mobileScrollSupport
        ref={book}
        showCover
        size="stretch"
        startPage={0}
        useMouseEvents
        width={510}
      >
        {images.map((image, index) => <AlbumPage image={image} key={image} number={index + 1} />)}
      </HTMLFlipBook>
      <div className="album-controls">
        <button onClick={() => book.current?.pageFlip().flipPrev()} data-testid="album-previous-button" aria-label="Önceki sayfa"><ChevronLeft size={20} /></button>
        <span data-testid="album-instruction-text">Sayfayı çevirin</span>
        <button onClick={() => book.current?.pageFlip().flipNext()} data-testid="album-next-button" aria-label="Sonraki sayfa"><ChevronRight size={20} /></button>
      </div>
    </div>
  );
}